export class GuidHelpers {
    public static generateGuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    //Methode pour verifier que le Guid est vide
    public static isEmptyGuid(guid: string): boolean {
        return guid === '00000000-0000-0000-0000-000000000000';
    }
}